import { action } from 'satcheljs';
import {
    QuickComposeEntrySourceType,
    FullComposeEntrySourceType,
    EventCompletionStatusType,
} from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';
import { ComposeFormType } from 'owa-calendar-helpers-types/lib/ComposeTypes';

export interface EndComposeFormSessionData {
    eventCompletionType: EventCompletionStatusType;
    quickComposeEntrySource: QuickComposeEntrySourceType;
    isAllDay: boolean;
    isNewEvent: boolean;
    formType: ComposeFormType;
    fullComposeEntrySource: FullComposeEntrySourceType;
    isGroupMailbox: boolean | undefined;
}

export const notifyEndComposeFormSession = action(
    'notifyEndComposeFormSession',
    (endComposeData: EndComposeFormSessionData) => ({ endComposeData })
);
